import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [],
  isLoading: false,
  error: null
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    // Set loading state for all requests
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    // Handle failure for all requests
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    // Fetch products success
    fetchProductsSuccess: (state, action) => {
      state.products = action.payload;
      state.isLoading = false;
    },
    // Add product success
    addProductSuccess: state => {
      state.isLoading = false;
    },
    // Update product success
    updateProductSuccess: (state, action) => {
      const { id, data } = action.payload;
      const index = state.products.findIndex(product => product.id === id);
      if (index !== -1) {
        state.products[index] = { ...state.products[index], ...data };
      }
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchProductsSuccess,
  addProductSuccess,
  updateProductSuccess
} = productsSlice.actions;

export default productsSlice.reducer;
